<div class="container">
  <img
    class="img-responsive"
    src="https://richardeigenmann.github.io/Rezeptsammlung/RichardHerbert.jpg"
    alt="Richard und Herbert mit Tablet und Kochbuch"
  />
  <p>
    <i>Richard Eigenmann und Herbert Eigenmann, 2013</i>
  </p>

  <p style="margin-bottom: 1cm"></p>

  <ul class="list-group">
    <li class="list-group-item">
      <h3 class="lead">48 Jahre Rezeptsammlung:</h3>
    </li>
    <li class="list-group-item">
      <span class="label label-primary">1978</span> Start des Sammelns von
      interessanten Rezepten in der K&uuml;chenschublade
    </li>
    <li class="list-group-item">
      <span class="label label-primary">1990</span> Erfassen der gesammelten
      Rezepte mit Lotus 123 auf Apple Macintosh
    </li>
    <li class="list-group-item">
      <span class="label label-primary">1994</span> Floppy Disk mit abgetippten
      Rezepten
    </li>
    <li class="list-group-item">
      <span class="label label-primary">1995</span> Erste Rezepte auf dem
      Internet
    </li>
    <li class="list-group-item">
      <span class="label label-primary">1999</span> Historische Version der
      Rezeptsammlung auf der
      <a
        href="http://web.archive.org/web/19991004125431/http://ourworld.compuserve.com/homepages/richard_eigenmann/Recipes.htm"
        >WayBackMachine</a
      >
    </li>
    <li class="list-group-item">
      <span class="label label-primary">2007</span>
      <a
        title="™/®The Apache Software Foundation, Apache License 2.0 &lt;http://www.apache.org/licenses/LICENSE-2.0&gt;, via Wikimedia Commons"
        href="https://commons.wikimedia.org/wiki/File:Apache_Tomcat_logo.svg"
        ><img
          style="width: 26px; height: auto"
          alt="Apache Tomcat logo"
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/fe/Apache_Tomcat_logo.svg/512px-Apache_Tomcat_logo.svg.png?20230726204155"
      /></a>
      Servlet basierte Version der Rezeptsammlung
    </li>
    <li class="list-group-item">
      <span class="label label-primary">2011</span>
      <img
        style="width: 24px; height: auto"
        src="http://eclipse.org/xtend/images/gwt-logo.png"
        alt="Google Web Toolkit"
      />
      Google Web Toolkit (GWT) Version der Rezeptsammlung
    </li>
    <!-- The Android robot is reproduced or modified from work created and shared by Google and used according to terms described in the Creative Commons 3.0 Attribution License. [CC-BY-3.0 (http://creativecommons.org/licenses/by/3.0)], via Wikimedia Commons" href="http://commons.wikimedia.org/wiki/File%3AAndroid_robot.svg" -->
    <li class="list-group-item">
      <span class="label label-primary">2012</span>
      <a href="https://richardeigenmann.pages.dev/recipesandroid.htm">
        <img
          width="16"
          alt="Android robot"
          src="//upload.wikimedia.org/wikipedia/commons/thumb/d/d7/Android_robot.svg/32px-Android_robot.svg.png"
        />
        Android Version</a
      >
      der Rezeptsammlung
    </li>
    <li class="list-group-item">
      <span class="label label-primary">2013</span>
      <img
        style="width: 23px; height: auto"
        src="http://www.w3.org/html/logo/downloads/HTML5_Logo.svg"
        alt="HTML5 Logo"
      />
      HTML 5 Version der Rezeptsammlung
    </li>
    <li class="list-group-item">
      <span class="label label-primary">2014</span>
      <img
        style="width: 90px; height: auto"
        src="https://angularjs.org/img/AngularJS-large.png"
        alt="Angular JS Logo"
      />
      Version der Rezeptsammlung
    </li>
    <li class="list-group-item">
      <span class="label label-primary">2017</span>
      <img
        style="width: 23px; height: auto"
        src="https://angular.io/assets/images/logos/angular/angular.svg"
        alt="Angular Logo"
      />
      Angular-2 Version der Rezeptsammlung
    </li>
    <li class="list-group-item">
      <span class="label label-primary">2025</span>
      <a href="https://richardeigenmann.github.io/RezeptsammlungNg">
        <img
          style="width: 23px; height: auto"
          src="https://angular.io/assets/images/logos/angular/angular.svg"
          alt="Angular Logo"
        />
        Angular-20 Version</a
      >
      der Rezeptsammlung. Source Code auf
      <a href="https://github.com/richardeigenmann/RezeptsammlungNg">Github</a>
      Rezepte:
      <a href="https://github.com/richardeigenmann/Rezeptsammlung">Github</a>
    </li>
  </ul>

  <br />
  <p>
    &Uuml;ber die Jahre sammelte meine Mutter Rezepte die ansatzweise
    Interessant klangen in der zweituntersten K&uuml;chenschublade.
  </p>
  <p>
    Mein Vater leerte die Schublade Anfang der 1990er Jahre und tippte die
    Rezepte in seinen Apple Macintosh Computer. Er speicherte jeweils ein bis
    zwei Rezepte in eine Lotus 123 Datei benannt nach Anfangsbuchstaben des
    Rezepttitels. Er druckte die Rezepte aus und erstellte so ein Ringkochbuch
    das seither in seiner Küche in Oberrieden steht,
  </p>
  <p>
    Zu Weihnachten 1994 schenkte er mir eine 3 1/2 Zoll Floppy Disk mit den
    gesammelten Werken.
  </p>
  <p>
    Ich formatierte 1995 die ca. 200 Rezepte in eine Lotus AmiPro TextDatei um
    und konnte so ein Rezeptbuch gestalten. Ohne Bilder gab das wenig her, so
    scannte ich mit einem geborgten Scanner die verf&uuml;gbaren Bilder ein.
  </p>
  <p>
    Im Herbst 1995 schickte mich mein damaliger Arbeitgeber f&uuml;r 6 Monate
    nach Slough by London. Dort lernte ich via Compuserve das Internet kennen
    und konnte eine Homepage einrichten. Ich schrieb die Rezepte f&uuml;r das
    Internet um und lud sie alle auf die Homepage.
  </p>
  <p>
    Ich habe selber auch fleissig Rezepte gesammelt, so dass die Sammlung heute
    mit 533 Rezepten da steht.
  </p>
  <p>
    Seit 2003 besitze ich eine Digitalkamera mit der ich meine eigenen
    Rezeptbilder schiessen kann. Ich setzte mir zum Ziel alle Rezepte selber
    auszuprobieren, zu fotografieren und zu bewerten. Dies ist nun fast
    vollst&auml;ndig erreicht.
  </p>
  <p>
    Feedback: &Uuml;ber die Jahre haben mich immer wieder freundliche Mails mit
    Kommentaren zu einzelnen Rezepten erreicht. Ich habe immer grosse Freude an
    solchen Wortmeldungen und habe die Kommentare oft zu den Rezepten
    hinzugef&uuml;gt.
  </p>
  <p>Ich hoffe Du hast genauso viel Freude an der Rezeptsammlung wie ich!</p>
  <p>Richard Eigenmann, 2026</p>
  <p>
    E-Mail:
    <a data-test="richard-email-link" href="mailto:richard.eigenmann@gmail.com"
      >richard.eigenmann&#64;gmail.com</a
    >
  </p>
</div>
